import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PostLoggerInterceptor } from './interceptors/post-logger.interceptor';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { CallbackComponent } from './auth/callback/callback.component';
import { HomeComponent } from './components/home/home.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExpedientesCrearComponent } from './components/expedientes-crear/expedientes-crear.component';
import { RutFormatDirective } from './shared/directives/rut-format.directive';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExpedientesListarComponent } from './components/expedientes-listar/expedientes-listar.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { ModalComponent } from './shared/components/modal/modal.component';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { ExpedientesDetalleComponent } from './components/expedientes-detalle/expedientes-detalle.component';
import { ButtonComponent } from './shared/components/button/button.component';
import { AlertaComponent } from './shared/components/alerta/alerta.component';
import { ExpedientesDetalleProrrogaComponent } from './components/expedientes-detalle-prorroga/expedientes-detalle-prorroga.component';
import { HeaderPrestadorComponent } from './shared/components/header/prestador/header-prestador.component';
import { HeaderExpedienteComponent } from './shared/components/header/expediente/header-expediente.component';
import { HeaderLicenciaComponent } from './shared/components/header/licencia/header-licencia.component';
import { UploadDocumentComponent } from './shared/components/documentos/upload/upload.component';
import { ExpedientesDetalleSubirDocumentosComponent } from './components/expedientes-detalle-subir-documentos/expedientes-detalle-subir-documentos.component';
import { ExpedientesDetalleVerDocumentosComponent } from './components/expedientes-detalle-ver-documentos/expedientes-detalle-ver-documentos.component'
import { ExpedientesDetalleHistorialComponent } from './components/expedientes-detalle-historial/expedientes-detalle-historial.component';
import { VerDocumentoComponent } from './components/expedientes-detalle-ver-documentos/ver-documento/ver-documento.component';
import { SafeUrlPipe } from './shared/pipes/safe.url.pipe';
import { TablaPrestadorComponent } from './components/expedientes-detalle-ver-documentos/tabla-prestador/tabla-prestador.component';
import { TablaGeneralComponent } from './components/expedientes-detalle-ver-documentos/tabla-general/tabla-general.component';
import { PreviewDocumentComponent } from './shared/components/documentos/preview/preview.component';
import { TemplateDocumentComponent } from './shared/components/documentos/template/template.component';
import { SancionComponent } from './shared/components/header/sancion/sancion.component';
import { ExpedientesDetalleApelacionComponent } from './components/expedientes-detalle-apelacion/expedientes-detalle-apelacion.component';
import { PlantillaDocumentoComponent } from './components/plantillas-documentos/plantillas-documentos.component';
import { CambioPerfilComponent } from './shared/components/select/cambio-perfil/cambio-perfil.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { ContainerComponent } from './shared/components/container/container.component';
import { NotFoundComponentComponent } from './components/not-found-component/not-found-component.component';
import { ExpedientesVerDocumentosComponent } from './components/expedientes-ver-documentos/expedientes-ver-documentos.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { IngresoComponent } from './components/ingreso/ingreso.component';
import { ConflictoSesionComponent } from './components/conflicto-sesion/conflicto-sesion.component';
import { SessionTimerComponent } from './components/session-timer/session-timer.component';
import { ConflictoSesionPageComponent } from './auth/conflicto-sesion-page/conflicto-sesion-page.component';
import { AppCard } from '@shared/components/card/card.component';
import { AppButtonClaveUnica } from '@shared/components/button/clave-unica/button-clave-unica.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    CallbackComponent,
    HomeComponent,
    ExpedientesCrearComponent,
    RutFormatDirective,
    ExpedientesListarComponent,
    SidebarComponent,
    UnauthorizedComponent,
    ModalComponent,
    LoadingComponent,
    ExpedientesDetalleComponent,
    ButtonComponent,
    AlertaComponent,
    ExpedientesDetalleProrrogaComponent,
    HeaderPrestadorComponent,
    HeaderExpedienteComponent,
    HeaderLicenciaComponent,
    UploadDocumentComponent,
    ExpedientesDetalleSubirDocumentosComponent,
    ExpedientesDetalleVerDocumentosComponent,
    VerDocumentoComponent,
    ExpedientesDetalleHistorialComponent,
    SafeUrlPipe,
    TablaPrestadorComponent,
    TablaGeneralComponent,
    PreviewDocumentComponent,
    TemplateDocumentComponent,
    SancionComponent,
    ExpedientesDetalleApelacionComponent,
    PlantillaDocumentoComponent,
    CambioPerfilComponent,
    BreadcrumbComponent,
    ContainerComponent,
    NotFoundComponentComponent,
    ExpedientesVerDocumentosComponent,
    IngresoComponent,
    ConflictoSesionComponent,
    SessionTimerComponent,
    ConflictoSesionPageComponent,
    AppCard,
    AppButtonClaveUnica
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    OAuthModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'custom-toast-container',
      maxOpened: 1, // máximo un mensaje al mismo tiempo
      autoDismiss: true, // cierra el anterior automáticamente
      preventDuplicates: true // evita duplicados del mismo mensaje
    }),
    NgSelectModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PostLoggerInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
